import { render } from "./kalio-form-helper.vue?vue&type=template&id=4b4fde26"
import script from "./kalio-form-helper.vue?vue&type=script&lang=js"
export * from "./kalio-form-helper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__